import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSpot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M14.796 7.256a5.752 5.752 0 1 0-7.54 7.54 7.25 7.25 0 0 1 7.54-7.54Zm1.32.175a.75.75 0 0 0 .078-.72A7.252 7.252 0 0 0 2.25 9.5a7.252 7.252 0 0 0 4.461 6.694.75.75 0 0 0 .72-.078 7.25 7.25 0 1 0 8.685-8.685ZM20.25 14.5a5.75 5.75 0 1 0-11.5 0 5.75 5.75 0 0 0 11.5 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M18.53 2.47a.75.75 0 0 1 .08.967c.345.116.69.284 1.014.515.942.673 1.626 1.827 1.626 3.548a.75.75 0 1 1-1.5 0c0-1.279-.483-1.959-.998-2.327-.557-.398-1.233-.49-1.646-.43a.75.75 0 0 1-.636-1.273l1-1a.75.75 0 0 1 1.06 0ZM5.47 21.53a.75.75 0 0 1-.08-.967 3.868 3.868 0 0 1-1.013-.515c-.943-.673-1.627-1.826-1.627-3.548a.75.75 0 0 1 1.5 0c0 1.279.483 1.959.998 2.327.557.398 1.234.49 1.646.43a.75.75 0 0 1 .636 1.273l-1 1a.75.75 0 0 1-1.06 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorSpot;
